export { CommonDeleteModalComponent } from './common-delete-modal/common-delete';
